import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

/**
 * X para ocultar los banners de créditos del Home (FINA-3378). La misma en todos: se coloca en la
 * esquina superior derecha del banner, que debe tener `position: relative` y aire a la derecha.
 * Solo emite; el banner decide qué ocultar (`banner-hide.util`). `tone` según el fondo.
 */
@Component({
    selector: 'fina-banner-close',
    template: `
        <button type="button" class="bc" aria-label="Ocultar" title="Ocultar" data-test="banner-close" (click)="dismiss.emit()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" />
            </svg>
        </button>
    `,
    styleUrls: ['./banner-close.component.scss'],
})
export class BannerCloseComponent {
    @Input() tone: 'dark' | 'light' = 'light';
    @Output() dismiss = new EventEmitter<void>();

    @HostBinding('class.bc-host--dark') get isDark(): boolean {
        return this.tone === 'dark';
    }
}
